var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "alert alert-info alert-dismissible fade show",
          attrs: { role: "alert" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c("p", [_vm._v("Create the ticket first, then come back here")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center align-items-center "
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Close"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        yes\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-info",
                    attrs: { target: "_blank", href: _vm.create_vip_ticket_uri }
                  },
                  [_vm._v("No, create now")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]
      ),
      _vm._v(" "),
      _vm.set_dev
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                {
                  class: {
                    yup: _vm.canImport,
                    nope: !_vm.canImport
                  }
                },
                [_vm._v("canImport\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    yup: _vm.ticketIsSelected,
                    nope: !_vm.ticketIsSelected
                  }
                },
                [_vm._v("ticketIsSelected\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    yup: _vm.ticketIsSelected,
                    nope: !_vm.ticketIsSelected
                  }
                },
                [_vm._v("ticketIsSelected\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    yup: _vm.uploaderIsInitial,
                    nope: !_vm.uploaderIsInitial
                  }
                },
                [_vm._v("uploaderIsInitial\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    yup: _vm.canAllocate,
                    nope: !_vm.canAllocate
                  }
                },
                [_vm._v("canAllocate\n                ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    yup: _vm.uploader_status,
                    nope: !_vm.uploader_status
                  }
                },
                [
                  _vm._v(
                    "uploader_status:" +
                      _vm._s(_vm.uploader_status) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    yup: _vm.hasImportedErrors,
                    nope: !_vm.hasImportedErrors
                  }
                },
                [_vm._v("imported_checklist.has_errors\n                ")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "navbar navbar-light" }, [
        _c("div", { staticClass: "row w-100" }, [
          _c(
            "div",
            { staticClass: "order-2 order-md-1 col-12 col-md-4 d-flex" },
            [
              _c("BaseSwitch", {
                staticClass: "px-2 w-100 align-self-center",
                attrs: {
                  tabindex: 0,
                  checked: _vm.isSeasonTicket(),
                  field: "status",
                  identifier: "status",
                  label: null,
                  switch_off: "Single Tickets",
                  switch_on: "Season Tickets",
                  title: "Select VIP ticket type",
                  tooltip: true
                },
                on: { input_value: _vm.switchToSeasonTicket }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "order-3 order-md-2 col-12 col-md-4" }, [
            _c(
              "section",
              {
                class: _vm.isSeasonTicket() ? "" : "d-none",
                attrs: { "data-ref": "SeasonTicketSelector" }
              },
              [
                _c(
                  "div",
                  { attrs: { id: "ticket_material_select--wrapper" } },
                  [
                    _c("material-select", {
                      ref: "ticket_chooser_select",
                      attrs: { id: _vm.season_ticket_chooser.id },
                      on: { material_select_result: _vm.ticketMaterialSelect }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                class: _vm.isSeasonTicket() ? "d-none" : "",
                attrs: { "data-ref": "SingleTicketSelector" }
              },
              [
                _c(
                  "div",
                  { attrs: { id: "material_select--wrapper" } },
                  [
                    _c("material-select", {
                      ref: "event_chooser_select",
                      attrs: { id: _vm.event_chooser.id },
                      on: { material_select_result: _vm.eventMaterialSelect }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order-4 order-md-3 col-6 col-md-3" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-100 d-flex justify-content-between align-content-center"
              },
              [
                _c(
                  "BaseButton",
                  {
                    attrs: {
                      cls: [
                        {
                          disabled: !_vm.canImport | _vm.uploaderIsSaving
                        },
                        "mx-auto align-self-center"
                      ]
                    },
                    on: { click: _vm.showImportDialog }
                  },
                  [_vm._v("Import CSV\n                        ")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order-1 order-md-3 col-1" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-100 d-flex justify-content-between align-content-center"
              },
              [
                _c(
                  "div",
                  { staticClass: "align-self-center" },
                  [
                    _c("add_to_bookmark", {
                      attrs: {
                        store: _vm.bookmark_store,
                        route: _vm.bookmark_route
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.import_file.show_import_dialog
            ? [
                _vm.uploaderIsInitial() || _vm.uploaderIsSaving()
                  ? _c(
                      "form",
                      {
                        attrs: {
                          enctype: "multipart/form-data",
                          novalidate: ""
                        }
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _vm.isSingleTicket()
                                ? [
                                    _c("material-select", {
                                      ref: "single_ticket_chooser_select",
                                      staticClass: "m0",
                                      attrs: {
                                        id: _vm.single_ticket_chooser.id,
                                        "data-ref":
                                          "single_ticket_chooser_select"
                                      },
                                      on: {
                                        material_select_result:
                                          _vm.singleMaterialTicketSelect
                                      }
                                    })
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "BaseButton",
                                    {
                                      attrs: {
                                        type: "div",
                                        small: true,
                                        btn_type: "btn-danger",
                                        cls: "mx-auto align-self-center"
                                      },
                                      on: { click: _vm.createTemplateCSV }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-content-center"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "align-self-center"
                                            },
                                            [_vm._v("Download Template")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "cursor-pointer material-icons"
                                            },
                                            [_vm._v("file_download")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.current_ticket_id !== null
                                ? _c("div", { staticClass: "dropbox" }, [
                                    _c("input", {
                                      staticClass: "input-file",
                                      attrs: {
                                        type: "file",
                                        name: _vm.uploadFieldName,
                                        disabled: _vm.uploaderIsSaving(),
                                        accept: _vm.import_file.csv_type
                                      },
                                      on: { change: _vm.uploadFileChange }
                                    }),
                                    _vm._v(" "),
                                    _vm.uploaderIsInitial()
                                      ? _c("p", [
                                          _vm._v(
                                            "\n                                    Drag your csv file here to begin"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " or click to browse\n                                "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.uploaderIsSaving()
                                      ? _c(
                                          "div",
                                          { staticClass: "p-3" },
                                          [
                                            _c("BaseLoadingAnimation", {
                                              attrs: {
                                                text:
                                                  "please wait while importing csv..."
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("bold-words", {
                                              staticClass:
                                                "text-center my-3 text-uppercase",
                                              attrs: {
                                                element_type: "div",
                                                word: {
                                                  text:
                                                    "do not refresh this page"
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.canImport
        ? [
            _vm.uploader_status
              ? _c(
                  "div",
                  {
                    staticClass: "alert fade show",
                    class: {
                      "alert-danger": _vm.imported_checklist.has_errors,
                      "alert-success alert-dismissible": !_vm.imported_checklist
                        .has_errors
                    },
                    attrs: { "data-ref": "import__dialog", role: "alert" }
                  },
                  [
                    _vm.imported_checklist.no_spaces === true
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-content-center"
                            },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end align-content-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "pl-1" },
                                    [
                                      _c(
                                        "BaseButton",
                                        {
                                          attrs: {
                                            type: "div",
                                            small: true,
                                            btn_type: "btn-danger",
                                            cls: "mx-auto align-self-center"
                                          },
                                          on: { click: _vm.exportToCSV }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "align-self-center"
                                                },
                                                [_vm._v("Download now")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "cursor-pointer material-icons"
                                                },
                                                [_vm._v("file_download")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pl-1" },
                                    [
                                      _c(
                                        "BaseButton",
                                        {
                                          attrs: {
                                            type: "div",
                                            small: true,
                                            btn_type: "btn-danger",
                                            cls: "mx-auto align-self-center"
                                          },
                                          on: { click: _vm.resetImporter }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "align-self-center"
                                                },
                                                [_vm._v("Close")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "cursor-pointer material-icons"
                                                },
                                                [_vm._v("close")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.getTotalFailedImports) +
                                " out of " +
                                _vm._s(_vm.getTotalSuccessfulImports) +
                                "\n                        " +
                                _vm._s(
                                  _vm.getTotalSuccessfulImports > 1
                                    ? "records were"
                                    : "record was"
                                ) +
                                " not imported. You must download\n                        the remaining records."
                            )
                          ])
                        ])
                      : _vm.imported_checklist.has_errors
                        ? _c(
                            "div",
                            [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between align-content-center"
                                  },
                                  [
                                    _c("h4", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "  d-flex justify-content-start align-items-center "
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "fs-5 material-icons mr-2"
                                            },
                                            [_vm._v("warning")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.imported_checklist.invalid
                                                  .count
                                              ) +
                                                " out of " +
                                                _vm._s(
                                                  _vm.getTotalSuccessfulImports
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.getTotalSuccessfulImports >
                                                  1
                                                    ? "records were"
                                                    : "record was"
                                                ) +
                                                " not imported"
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-end align-content-center"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pl-1" },
                                          [
                                            _c(
                                              "BaseButton",
                                              {
                                                attrs: {
                                                  type: "div",
                                                  small: true,
                                                  btn_type: "btn-secondary",
                                                  cls:
                                                    "mx-auto align-self-center"
                                                },
                                                on: { click: _vm.exportToCSV }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between align-content-center"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "align-self-center"
                                                      },
                                                      [_vm._v("Export")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "cursor-pointer material-icons"
                                                      },
                                                      [_vm._v("file_download")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pl-1" },
                                          [
                                            _c(
                                              "BaseButton",
                                              {
                                                attrs: {
                                                  type: "div",
                                                  small: true,
                                                  btn_type: "btn-danger",
                                                  cls:
                                                    "mx-auto align-self-center"
                                                },
                                                on: { click: _vm.resetImporter }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between align-content-center"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "align-self-center"
                                                      },
                                                      [_vm._v("Close")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "cursor-pointer material-icons"
                                                      },
                                                      [_vm._v("close")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "small" }, [
                                _vm._v(
                                  "Correct each highlighted field and hit Enter on the keyboard to check. Once\n                        there are no highlighted fields, click the Update button to send a"
                                )
                              ]),
                              _vm._v(" "),
                              _c("TableEditor", {
                                attrs: {
                                  headers: _vm.imported_checklist.headers,
                                  records: _vm.imported_checklist.invalid.data,
                                  validate: {
                                    use: true,
                                    url: _vm.import_ticket_validate_field_url
                                  },
                                  button_title: "Update",
                                  submit_url: _vm.uploaderUrl,
                                  submit_additional_params: {
                                    selected_ticket: _vm.getSelectedTicket
                                  }
                                },
                                on: { complete: _vm.invalidRecordsCorrected }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("h4", [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "  d-flex justify-content-start align-items-center "
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "fs-5 material-icons mr-2"
                                      },
                                      [_vm._v("check")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.total_imported) +
                                          " " +
                                          _vm._s(
                                            _vm.total_imported > 0
                                              ? "Imports have"
                                              : "Import has"
                                          ) +
                                          " been scheduled for creation"
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "small" }, [
                                _vm._v(
                                  "Records are imported in the background, which may take some time to create.\n                        This\n                        is\n                        dependant on multiple reasons such as server load."
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "small" }, [
                                _vm._v(
                                  "If you wish to check the status of the imports please come back after some\n                        time"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "BaseButton",
                                { on: { click: _vm.resetImporter } },
                                [_vm._v("Thank you.\n                    ")]
                              )
                            ],
                            1
                          )
                  ]
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSingleTicket()
        ? [
            _vm.table_list_active && _vm.editing_single_sale
              ? _c("div", { staticClass: "table-responsive" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-responsive-sm table-bordered table-striped"
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm.loading_spaces_available
                            ? _c("tr", [
                                _c("td", { attrs: { colspan: "3" } }, [
                                  _vm._v("Loading")
                                ])
                              ])
                            : _vm._l(_vm.selected_tickets_for_event, function(
                                ticket
                              ) {
                                return _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(ticket.lang.en_GB.title))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(ticket.allocated))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(ticket.spaces))])
                                ])
                              })
                        ],
                        2
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("section", {}, [
        _vm.table_list_active
          ? _c("div", { attrs: { "data-ref": "season--table_list_active" } }, [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column",
                    class: {
                      "flex-md-row justify-content-between align-content-center": _vm.isSeasonTicket()
                    }
                  },
                  [
                    _vm.isSeasonTicket() && _vm.table_list_active
                      ? [
                          _vm.loading_spaces_available
                            ? [_c("div", [_vm._v("Loading")])]
                            : _vm._l(_vm.selected_tickets_for_event, function(
                                ticket
                              ) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-sm-row mt-2 mt-sm-0 justify-content-between align-content-center"
                                    },
                                    [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex px-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-self-center pr-1"
                                              },
                                              [_vm._v("Allocated:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-self-center badge badge-pill badge-info"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(ticket.allocated) +
                                                    "\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex pr-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-self-center pr-1"
                                              },
                                              [_vm._v("Spaces Available:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-self-center badge badge-pill",
                                                class: {
                                                  "badge-danger":
                                                    ticket.spaces <= 0,
                                                  "badge-info":
                                                    ticket.spaces > 0
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(ticket.spaces) +
                                                    "\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "d-flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex pr-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-self-center "
                                              },
                                              [
                                                _c(
                                                  "BaseButton",
                                                  {
                                                    attrs: {
                                                      small: true,
                                                      type: "a",
                                                      href: _vm.getTicketRoute(
                                                        ticket
                                                      ),
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-between align-content-center"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "align-self-center"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "View Ticket"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons"
                                                          },
                                                          [_vm._v("pageview")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              })
                        ]
                      : [
                          _c("div", { staticClass: "card " }, [
                            _vm.table_list_active
                              ? _c("div", { staticClass: "card-body" }, [
                                  _c(
                                    "div",
                                    { staticClass: "table-responsive" },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-sm table-hover thead-light"
                                        },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "cursor-pointer w-50",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.view_all_allocations = !_vm.view_all_allocations
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-inline-block"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Ticket" +
                                                            _vm._s(
                                                              _vm.selected_tickets_for_event !==
                                                                null &&
                                                              _vm
                                                                .selected_tickets_for_event
                                                                .length > 1
                                                                ? "s"
                                                                : ""
                                                            ) +
                                                            "\n                                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-inline-block position-relative"
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons position-absolute",
                                                            staticStyle: {
                                                              bottom: "-7px",
                                                              right: "-20px",
                                                              position:
                                                                "absolute"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                " +
                                                                _vm._s(
                                                                  _vm.view_all_allocations
                                                                    ? "expand_less"
                                                                    : "expand_more"
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                {
                                                  staticClass: "cursor-pointer"
                                                },
                                                [_vm._v("Allocated")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                {
                                                  staticClass: "cursor-pointer"
                                                },
                                                [_vm._v("Spaces Available")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                {
                                                  staticClass: "cursor-pointer"
                                                },
                                                [_vm._v("Edit ticket")]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _vm.loading_spaces_available
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "3" }
                                                      },
                                                      [_vm._v("Loading")]
                                                    )
                                                  ])
                                                : [
                                                    _vm._l(
                                                      _vm.selected_tickets_for_event,
                                                      function(ticket) {
                                                        return [
                                                          _vm.show_allocations(
                                                            ticket
                                                          )
                                                            ? _c(
                                                                "tr",
                                                                {
                                                                  staticClass:
                                                                    "cursor-pointer",
                                                                  class: {
                                                                    "table-info":
                                                                      _vm.view_single_ticket !==
                                                                        null &&
                                                                      ticket.id ===
                                                                        _vm
                                                                          .view_single_ticket
                                                                          .id
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.showOneTicketOnly(
                                                                        ticket
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket
                                                                          .lang
                                                                          .en_GB
                                                                          .title
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket.allocated
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket.spaces
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "td",
                                                                    [
                                                                      _c(
                                                                        "BaseButton",
                                                                        {
                                                                          attrs: {
                                                                            small: true,
                                                                            type:
                                                                              "a",
                                                                            href: _vm.getTicketRoute(
                                                                              ticket
                                                                            ),
                                                                            target:
                                                                              "_blank"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex justify-content-between align-content-center"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "align-self-center"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "View Ticket"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "material-icons"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "pageview"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("tfoot", [
                                            _vm.view_single_ticket === null
                                              ? _c("tr", [
                                                  _c("td", [
                                                    _vm._v("All Tickets")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getTotalAllocation
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(_vm.getTotalSpaces)
                                                    )
                                                  ])
                                                ])
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: " d-flex",
                        class: {
                          "flex-column flex-sm-row  justify-content-between align-content-center": _vm.isSeasonTicket(),
                          "justify-content-end align-content-center": _vm.isSingleTicket()
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pr-4 d-flex w-100 w-sm-75 w-md-initial"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchString,
                                  expression: "searchString"
                                }
                              ],
                              staticClass: "align-self-center",
                              attrs: { type: "text", placeholder: "Customer" },
                              domProps: { value: _vm.searchString },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.searchString = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-content-center"
                          },
                          [
                            _c("BaseIconButton", {
                              attrs: {
                                float: true,
                                theme: "btn-secondary",
                                icon: {
                                  content: "refresh"
                                },
                                tag_name: "div"
                              },
                              on: {
                                click_event: function($event) {
                                  _vm.loadRows()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("BaseIconButton", {
                              staticClass: "btn-primary",
                              attrs: {
                                float: true,
                                icon: {
                                  content: "skip_previous"
                                },
                                tag_name: "div"
                              },
                              on: { click_event: _vm.prevPage }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-content-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "align-self-center badge badge-pill badge-info"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.currentPage) +
                                        "\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "small align-self-center mx-1 text-muted"
                                  },
                                  [_vm._v("of")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "align-self-center badge badge-pill badge-info"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.number_of_pages) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("BaseIconButton", {
                              staticClass: "btn-primary",
                              attrs: {
                                float: true,
                                theme: !_vm.can_use_next
                                  ? "disabled"
                                  : "active",
                                icon: {
                                  content: "skip_next"
                                },
                                tag_name: "div"
                              },
                              on: { click_event: _vm.nextPage }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "table-responsive" },
                  [
                    _c(
                      "table",
                      { staticClass: "table table-sm table-hover thead-dark" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "cursor-cell",
                                on: {
                                  click: function($event) {
                                    _vm.sort("created_at")
                                  }
                                }
                              },
                              [_vm._v("Created")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "cursor-cell text-nowrap",
                                on: {
                                  click: function($event) {
                                    _vm.sort("first_name")
                                  }
                                }
                              },
                              [_vm._v("First name")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "cursor-cell text-nowrap",
                                on: {
                                  click: function($event) {
                                    _vm.sort("last_name")
                                  }
                                }
                              },
                              [_vm._v("Last name")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "cursor-cell",
                                on: {
                                  click: function($event) {
                                    _vm.sort("email")
                                  }
                                }
                              },
                              [_vm._v("Email")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "cursor-cell",
                                on: {
                                  click: function($event) {
                                    _vm.sort("telephone")
                                  }
                                }
                              },
                              [_vm._v("Telephone")]
                            ),
                            _vm._v(" "),
                            _c("th", { staticClass: "cursor-pointer" }, [
                              _vm._v("Plates")
                            ]),
                            _vm._v(" "),
                            _vm.isSingleTicket()
                              ? _c(
                                  "th",
                                  {
                                    staticClass: "cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.sort("ticket")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Ticket\n                                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", { staticClass: "cursor-pointer" }, [
                              _vm._v("Spaces")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticClass: "cursor-pointer text-center" },
                              [_vm._v("Actions")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            true
                              ? [
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _c(
                                        "tr",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.create_new_record_state,
                                              expression:
                                                "create_new_record_state"
                                            }
                                          ],
                                          class: _vm.editing_single_sale
                                            ? "red"
                                            : ""
                                        },
                                        [
                                          _c("td", {
                                            attrs: { "data-info": "created_at" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                "data-info": "first_name"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "d-flex flex-row"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.new_row
                                                            .first_name,
                                                        expression:
                                                          "new_row.first_name"
                                                      }
                                                    ],
                                                    attrs: {
                                                      title: "first_name",
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.new_row.first_name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.new_row,
                                                          "first_name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn-floating btn-sm"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-search"
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                "data-info": "last_name"
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.new_row.last_name,
                                                    expression:
                                                      "new_row.last_name"
                                                  }
                                                ],
                                                attrs: {
                                                  title: "last_name",
                                                  type: "text"
                                                },
                                                domProps: {
                                                  value: _vm.new_row.last_name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.new_row,
                                                      "last_name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.new_row.email,
                                                  expression: "new_row.email"
                                                }
                                              ],
                                              staticClass: "validate",
                                              attrs: {
                                                title: "email",
                                                type: "email"
                                              },
                                              domProps: {
                                                value: _vm.new_row.email
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.new_row.email === ""
                                                    ? (_vm.new_row.spaces = 1)
                                                    : ""
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.new_row,
                                                    "email",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                "data-info": "telephone"
                                              }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.new_row.telephone,
                                                    expression:
                                                      "new_row.telephone"
                                                  }
                                                ],
                                                attrs: {
                                                  title: "spaces",
                                                  type: "text"
                                                },
                                                domProps: {
                                                  value: _vm.new_row.telephone
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.new_row,
                                                      "telephone",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { "data-info": "plate" } },
                                            [
                                              _vm.new_row.spaces === 1
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.new_row.plate,
                                                        expression:
                                                          "new_row.plate"
                                                      }
                                                    ],
                                                    attrs: {
                                                      title: "plate",
                                                      maxlength:
                                                        _vm.plate_length,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value: _vm.new_row.plate
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.new_row,
                                                          "plate",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _c("small", [
                                                    _vm._v(
                                                      "You can edit plates afterwards"
                                                    )
                                                  ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.isSingleTicket()
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    "data-ref":
                                                      "import_single_ticket_chooser_select"
                                                  }
                                                },
                                                [
                                                  _c("material-select", {
                                                    ref:
                                                      "import_single_ticket_chooser_select",
                                                    staticClass: "m0",
                                                    attrs: {
                                                      id:
                                                        _vm
                                                          .single_ticket_chooser
                                                          .id,
                                                      "data-ref":
                                                        "import_single_ticket_chooser_select"
                                                    },
                                                    on: {
                                                      material_select_result:
                                                        _vm.singleMaterialTicketSelect
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              attrs: { "data-info": "spaces" }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.new_row.spaces,
                                                    expression: "new_row.spaces"
                                                  }
                                                ],
                                                attrs: {
                                                  disabled:
                                                    _vm.new_row.email === "",
                                                  min: "1",
                                                  value: "1",
                                                  type: "number",
                                                  title: "spaces"
                                                },
                                                domProps: {
                                                  value: _vm.new_row.spaces
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.new_row,
                                                      "spaces",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                "data-info":
                                                  "create_new_record_state"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex justify-content-around align-items-center cursor-pointer",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.create_new_record_state = false
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons"
                                                    },
                                                    [_vm._v("cancel")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "tr",
                                    {
                                      class: _vm.editing_single_sale
                                        ? "d-none"
                                        : ""
                                    },
                                    [
                                      _c("td"),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.new_row.first_name,
                                              expression: "new_row.first_name"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            title: "first_name"
                                          },
                                          domProps: {
                                            value: _vm.new_row.first_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_row,
                                                "first_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.new_row.last_name,
                                              expression: "new_row.last_name"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            title: "last_name"
                                          },
                                          domProps: {
                                            value: _vm.new_row.last_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_row,
                                                "last_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.new_row.email,
                                              expression: "new_row.email"
                                            }
                                          ],
                                          staticClass: "validate",
                                          attrs: {
                                            type: "email",
                                            title: "email"
                                          },
                                          domProps: {
                                            value: _vm.new_row.email
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.new_row.email === ""
                                                ? (_vm.new_row.spaces = 1)
                                                : ""
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_row,
                                                "email",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.new_row.telephone,
                                              expression: "new_row.telephone"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            title: "telephone"
                                          },
                                          domProps: {
                                            value: _vm.new_row.telephone
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_row,
                                                "telephone",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm.new_row.spaces === 1
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.new_row.plate,
                                                  expression: "new_row.plate"
                                                }
                                              ],
                                              attrs: {
                                                type: "text",
                                                title: "plate"
                                              },
                                              domProps: {
                                                value: _vm.new_row.plate
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.new_row,
                                                    "plate",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          : _c("small", [
                                              _vm._v(
                                                "You can edit plates afterwards"
                                              )
                                            ])
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.new_row.spaces,
                                              expression: "new_row.spaces"
                                            }
                                          ],
                                          attrs: {
                                            disabled: _vm.new_row.email === "",
                                            min: "1",
                                            value: "1",
                                            title: "spaces",
                                            type: "number"
                                          },
                                          domProps: {
                                            value: _vm.new_row.spaces
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_row,
                                                "spaces",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center align-items-center"
                                          },
                                          [
                                            !_vm.editing_single_sale
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-sm btn-primary",
                                                    attrs: {
                                                      "data-element-type":
                                                        "!editing_single_sale"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.submitNewRow()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "material-icons"
                                                      },
                                                      [_vm._v("add")]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                            _vm._v(" "),
                            _vm.loading_rows
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: "9" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Loading\n                                "
                                      )
                                    ]
                                  )
                                ])
                              : _vm.rows.length > 0
                                ? _vm._l(_vm.sortedCats, function(row) {
                                    return _c(
                                      "tr",
                                      { staticClass: "cursor-default" },
                                      [
                                        _c("td", {
                                          staticClass: "text-nowrap",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.readDate(row.created_at)
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.editing_single_sale && row.editing
                                            ? _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editing_row
                                                          .first_name,
                                                      expression:
                                                        "editing_row.first_name"
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: "first_name",
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.editing_row.first_name
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.editing_row,
                                                        "first_name",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("div", [
                                                _vm.canLink(row, "first_name")
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.createUserLink(
                                                            row
                                                          ),
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              row.first_name
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(row.first_name)
                                                      )
                                                    ])
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.editing_single_sale && row.editing
                                            ? _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editing_row
                                                          .last_name,
                                                      expression:
                                                        "editing_row.last_name"
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: "last_name",
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.editing_row.last_name
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.editing_row,
                                                        "last_name",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("div", [
                                                _vm.canLink(row, "last_name")
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.createUserLink(
                                                            row
                                                          ),
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              row.last_name
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(row.last_name)
                                                      )
                                                    ])
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.editing_single_sale && row.editing
                                            ? _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editing_row.email,
                                                      expression:
                                                        "editing_row.email"
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: "email",
                                                    type: "text",
                                                    disabled: ""
                                                  },
                                                  domProps: {
                                                    value: _vm.editing_row.email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.editing_row,
                                                        "email",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("div", [
                                                _vm.canLink(row, "email")
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.mailToUserLink(
                                                            row
                                                          ),
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(row.email) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(_vm._s(row.email))
                                                    ])
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.editing_single_sale && row.editing
                                            ? _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editing_row
                                                          .telephone,
                                                      expression:
                                                        "editing_row.telephone"
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: "telephone",
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.editing_row.telephone
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.editing_row,
                                                        "telephone",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("div", [
                                                _vm.canLink(row, "telephone")
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.TelUserLink(
                                                            row
                                                          ),
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              row.telephone
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(row.telephone)
                                                      )
                                                    ])
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.editing_single_sale && row.editing
                                            ? _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editing_row.plate,
                                                      expression:
                                                        "editing_row.plate"
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: "plate",
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value: _vm.editing_row.plate
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.editing_row,
                                                        "plate",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("div", [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-sm btn-secondary",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.listPlates(row)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Plates\n                                        "
                                                    )
                                                  ]
                                                )
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _vm.isSingleTicket()
                                          ? _c(
                                              "td",
                                              { staticClass: "text-nowrap" },
                                              [
                                                _vm._v(
                                                  _vm._s(row.ticket) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm.editing_single_sale && row.editing
                                            ? _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.editing_row.spaces,
                                                      expression:
                                                        "editing_row.spaces"
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: "spaces",
                                                    type: "number",
                                                    disabled:
                                                      _vm.editing_row.email ===
                                                      "",
                                                    min: "1",
                                                    value: "1"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.editing_row.spaces
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.editing_row,
                                                        "spaces",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("div", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(row.spaces) +
                                                    "\n                                    "
                                                )
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          !_vm.editing_single_sale
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "btn-group-sm d-block d-md-flex  justify-content-between align-items-center "
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn-floating btn-sm btn-info mr-3",
                                                      attrs: {
                                                        href: _vm.createUserLink(
                                                          row
                                                        ),
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons"
                                                        },
                                                        [_vm._v("face")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn-floating btn-sm btn-secondary mr-3",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.editSale(row)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons"
                                                        },
                                                        [_vm._v("edit")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn-floating btn-sm btn-danger",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.confirmRemove(row)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "delete_forever"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : row.editing
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "btn-group-sm d-block d-md-flex  justify-content-between align-items-center"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn-floating btn-sm btn-primary mr-2",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.submitSaleEdit(
                                                              row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons"
                                                          },
                                                          [_vm._v("save")]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn-floating btn-sm btn-secondary",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.cancelSaleEdit(
                                                              row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons"
                                                          },
                                                          [_vm._v("cancel")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                        ])
                                      ]
                                    )
                                  })
                                : _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "8" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    List is empty\n                                "
                                        )
                                      ]
                                    )
                                  ])
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    true
                      ? [
                          _vm.create_new_record_state
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "fixed-action-btn-est btn-floating---submit ",
                                    staticStyle: {
                                      bottom: "45px",
                                      right: "24px"
                                    },
                                    attrs: {
                                      "data-element-type":
                                        "create_new_record_state"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.submitNewRow()
                                      }
                                    }
                                  },
                                  [_vm._m(4)]
                                )
                              ])
                            : _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "fixed-action-btn-est btn-floating---submit ",
                                    staticStyle: {
                                      bottom: "45px",
                                      right: "24px"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.create_new_record_state = true
                                      }
                                    }
                                  },
                                  [_vm._m(5)]
                                )
                              ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "platesEditingModel",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "platesEditingModelLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "platesEditingModelLabel" }
                      },
                      [
                        _vm._v(
                          "Plates for -\n                                "
                        ),
                        _c("b", [_vm._v(_vm._s(_vm.editing_plates.email))])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(6)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center "
                      },
                      [
                        _c("div", [
                          _c("p", [
                            _vm._v("Create, update or add new plate here")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { "data-ref": "plates list" } },
                            [
                              _vm._l(_vm.editing_plates.plates, function(
                                plate,
                                index,
                                idx
                              ) {
                                return [
                                  _c("div", { staticClass: "md-form" }, [
                                    plate.original_value
                                      ? _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons prefix d-none d-md-flex"
                                          },
                                          [_vm._v("create")]
                                        )
                                      : _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons prefix d-none d-md-flex"
                                          },
                                          [_vm._v("add")]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watch-transition w-100 p-0 d-flex  justify-content-center align-items-center"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: plate.new_value,
                                              expression: "plate.new_value"
                                            }
                                          ],
                                          ref: "plate_" + index,
                                          refInFor: true,
                                          staticClass: "plate",
                                          attrs: {
                                            type: "text",
                                            data_ref:
                                              "editing_plates.plates[" +
                                              index +
                                              "]",
                                            title: "plate",
                                            maxlength: _vm.plate_length,
                                            disabled:
                                              plate.to_delete || plate.alt
                                          },
                                          domProps: { value: plate.new_value },
                                          on: {
                                            keyup: [
                                              function($event) {
                                                _vm.onPlateInput(
                                                  index,
                                                  "plate_"
                                                )
                                              },
                                              function($event) {
                                                if (!$event.altKey) {
                                                  return null
                                                }
                                                _vm.altKeyPressed(index, false)
                                              }
                                            ],
                                            keydown: function($event) {
                                              if (!$event.altKey) {
                                                return null
                                              }
                                              _vm.altKeyPressed(index, true)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                plate,
                                                "new_value",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn-floating btn-sm btn-danger",
                                          on: {
                                            click: function($event) {
                                              _vm.removePlateFromEditingList(
                                                plate,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete_forever")]
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  plate.alt
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "small p-1 m-1 bg-warning z-depth-1 align-center cursor-pointer",
                                          on: {
                                            click: function($event) {
                                              _vm.altKeyPressed(index, false)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                Do not press the Alt key. Click here to continue editing the plate\n                                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn-floating btn-primary",
                        on: {
                          click: function($event) {
                            _vm.editing_plates.plates.push({
                              original_value: null, //new entry
                              new_value: "",
                              to_delete: false,
                              created_by: _vm.user_id
                            })
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-plus" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.submitPlateChangesOfUser()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Save\n                                changes\n                            "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          {
            staticClass: "modal-danger modal fade",
            attrs: {
              id: "assetDecideModal",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "assetDecideModalLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-full-height modal-top",
                attrs: { role: "document" }
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "assetDecideModalLabel" }
                      },
                      [_vm._v(_vm._s(_vm.submit_error.title))]
                    ),
                    _vm._v(" "),
                    _vm._m(7)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex  justify-content-center align-items-center "
                      },
                      [
                        _c("div", [
                          _c("h5", [
                            _vm._v(
                              "Plate entered, belongs to a different user (email)"
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _vm.submit_error.extra_info.submitted_user
                            ? _c("div", { staticClass: "container" }, [
                                _c("div", { staticClass: "card-columns" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card bg-primary text-white"
                                    },
                                    [
                                      _vm._m(9),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "card-body" }, [
                                        _c(
                                          "ul",
                                          { staticClass: "list-unstyled" },
                                          [
                                            _c("li", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-lowercase font-weight-light"
                                                },
                                                [_vm._v("first_name:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .submitted_user.first_name
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-lowercase font-weight-light"
                                                },
                                                [_vm._v("last_name:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .submitted_user.last_name
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-lowercase font-weight-light"
                                                },
                                                [_vm._v("email:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .submitted_user.email
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-lowercase font-weight-light"
                                                },
                                                [_vm._v("telephone:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .submitted_user.telephone
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-lowercase font-weight-light"
                                                },
                                                [_vm._v("created_at:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .submitted_user.created_at
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            on: {
                                              click: function($event) {
                                                _vm.resubmitToCreateNewPlate()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Add this\n                                                        plate to this user\n                                                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card bg-secondary text-white"
                                    },
                                    [
                                      _vm._m(10),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "card-body" }, [
                                        _c(
                                          "ul",
                                          { staticClass: "list-unstyled" },
                                          [
                                            _c("li", {}, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light text-lowercase"
                                                },
                                                [_vm._v("first_name:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .other_user.first_name
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", {}, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light text-lowercase"
                                                },
                                                [_vm._v("last_name:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .other_user.last_name
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", {}, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light text-lowercase"
                                                },
                                                [_vm._v("email:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .other_user.email
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", {}, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light text-lowercase"
                                                },
                                                [_vm._v("telephone:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .other_user.telephone
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("li", {}, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light text-lowercase"
                                                },
                                                [_vm._v("created_at:")]
                                              ),
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.submit_error.extra_info
                                                      .other_user.created_at
                                                  ) +
                                                  "\n                                                        "
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-danger",
                                            on: {
                                              click: function($event) {
                                                _vm.resubmitChangingTheEmail(
                                                  _vm.submit_error.extra_info
                                                    .other_user.email
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                        Use this user instead\n                                                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" })
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          {
            staticClass: "modal-danger modal fade",
            attrs: {
              id: "assetDecideMultipleModal",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "assetDecideMultipleModalLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-full-height modal-top",
                attrs: { role: "document" }
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "assetDecideMultipleModalLabel" }
                      },
                      [_vm._v(_vm._s(_vm.submit_error.title))]
                    ),
                    _vm._v(" "),
                    _vm._m(11)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex  justify-content-center align-items-center "
                      },
                      [
                        _c("div", [
                          _c("h5", [_vm._v("Check the plate")]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "plate" }, [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(_vm.new_row.plate) +
                                  "\n                                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Another user has registered this plate. It cannot be assigned to this user\n                                        "
                              )
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.submit_error.extra_info.assets
                      ? _c("div", { staticClass: "container" }, [
                          _c("table", { staticClass: "table table-sm" }, [
                            _vm._m(12),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.submit_error.extra_info.assets,
                                function(asset) {
                                  return _c("tr", [
                                    asset.user_assets_group.user
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                asset.user_assets_group.user
                                                  .first_name
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                      : _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              asset.user_assets_group
                                                .user_assets_group_data
                                                .first_name
                                            ) +
                                              "\n                                        "
                                          )
                                        ]),
                                    _vm._v(" "),
                                    asset.user_assets_group.user
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                asset.user_assets_group.user
                                                  .last_name
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                      : _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              asset.user_assets_group
                                                .user_assets_group_data
                                                .last_name
                                            )
                                          )
                                        ]),
                                    _vm._v(" "),
                                    asset.user_assets_group.user
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                asset.user_assets_group.user
                                                  .telephone
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                      : _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              asset.user_assets_group
                                                .user_assets_group_data
                                                .telephone
                                            )
                                          )
                                        ]),
                                    _vm._v(" "),
                                    asset.user_assets_group.user
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                asset.user_assets_group.user
                                                  .email
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                      : _c("td"),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(asset.value))]),
                                    _vm._v(" "),
                                    asset.user_assets_group.user
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                asset.user_assets_group.user
                                                  .created_at
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                      : _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              asset.user_assets_group.created_at
                                            )
                                          )
                                        ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      asset.user_assets_group.user
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-primary",
                                              attrs: {
                                                "data-dismiss": "modal"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.resubmitChangingTheEmail(
                                                    asset.user_assets_group.user
                                                      .email
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                Use\n                                            "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-primary",
                                              attrs: {
                                                "data-dismiss": "modal"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.resubmitWithUserAssetsGroup(
                                                    asset.user_assets_group.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                Use\n                                            "
                                              )
                                            ]
                                          )
                                    ])
                                  ])
                                }
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(13)
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          {
            staticClass: "modal-danger modal fade",
            attrs: {
              id: "genericErrorModal",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "genericErrorModalLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "genericErrorModalLabel" }
                      },
                      [_vm._v(_vm._s(_vm.submit_error.title))]
                    ),
                    _vm._v(" "),
                    _vm._m(14)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex  justify-content-center align-items-center "
                      },
                      [_c("p", [_vm._v(_vm._s(_vm.submit_error.message))])]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(15)
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          {
            staticClass: "modal-danger modal fade",
            attrs: {
              id: "confirmRemoveModal",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "confirmRemoveModalLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _vm._m(16),
                  _vm._v(" "),
                  _vm._m(17),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [_vm._v("Cancel Action")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function($event) {
                            _vm.cancelReservation()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Cancel Reservation\n                            "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c(
        "span",
        { staticClass: "  d-flex justify-content-start align-items-center " },
        [
          _c("i", { staticClass: "fs-5 material-icons mr-2" }, [
            _vm._v("info")
          ]),
          _vm._v(" "),
          _c("span", {}, [_vm._v("Have you created the vip ticket yet?")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "alert",
          "aria-label": "Close"
        }
      },
      [
        _c(
          "i",
          { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
          [_vm._v("close")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c(
        "span",
        { staticClass: "d-flex justify-content-start align-items-center " },
        [
          _c("i", { staticClass: "fs-5 material-icons mr-2" }, [
            _vm._v("warning")
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("No more spaces available.")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Ticket")]),
        _vm._v(" "),
        _c("td", [_vm._v("Allocated")]),
        _vm._v(" "),
        _c("td", [_vm._v("Spaces Available")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "animated pulse waves-effect waves-light btn-floating btn-floating--single btn-lg border-0 ",
        attrs: { "data-icon-button": "" }
      },
      [
        _c(
          "i",
          { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
          [_vm._v("save")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "animated pulse waves-effect waves-light btn-floating btn-floating--single btn-lg border-0 ",
        attrs: { "data-icon-button": "" }
      },
      [
        _c(
          "i",
          { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
          [_vm._v("add")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [
        _c(
          "i",
          { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
          [_vm._v("close")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "Check the details and confirm that the plate you entered is correct."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("You created")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("User Found")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("First Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Last Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Telephone")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Plate")]),
        _vm._v(" "),
        _c("th", [_vm._v("Created At")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("Cancel")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("Close")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        {
          staticClass: "modal-title",
          attrs: { id: "confirmRemoveModalLabel" }
        },
        [_vm._v("Confirm")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c(
        "div",
        { staticClass: "d-flex  justify-content-center align-items-center " },
        [_c("p", [_vm._v("Are you sure you want delete this reservation?")])]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aec192bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec192bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/ticketing/VipTicketsAdminListEdit.vue
// module id = 718
// module chunks = 0